<template>
  <v-layout row wrap>
    <v-flex xs12 md5 :class="{ 'mr-5': $vuetify.breakpoint.smAndUp }">
      <v-btn
        v-if="plates.length === 0"
        color="accent"
        round
        outline
        class="initialize ml-0"
        block
        @click="isShowingPlateCreateBottomSheet = true"
      >
        <v-icon left>mdi mdi-car</v-icon>
        {{ $t('plates.createPlate.title') }}
        <v-spacer></v-spacer>
        <v-icon right>mdi mdi-alert</v-icon>
      </v-btn>
      <v-select
        v-else
        v-model="plateSelected"
        :items="internalPlates"
        item-text="code"
        item-value="code"
        :hint="plateSelected.alias"
        persistent-hint
        return-object
        :rules="plateRules"
        :label="$t('global.vehicle')"
        prepend-icon="mdi mdi-car"
        required
      ></v-select>
    </v-flex>
    <create-plate
      v-if="isShowingPlateCreateBottomSheet"
      @on-success="updatePlates"
      @on-close="closePlateCreateBottomSheet"
    ></create-plate>
  </v-layout>
</template>
<script>
import _ from 'lodash';
import CreatePlate from '@/components/private/user/CreatePlate';

export default {
  name: 'ReservationPlateSelection',
  components: {
    [CreatePlate.name]: CreatePlate
  },
  props: {
    plates: {
      type: Array,
      required: true
    },
    plateCodeSelected: {
      type: String
    }
  },
  data() {
    return {
      plateSelected: { code: '' },
      previousPlateSelected: null,
      internalPlates: [],
      isShowingPlateCreateBottomSheet: false
    };
  },
  computed: {
    plateRules() {
      return [
        (v) => {
          return (
            v.code !== '' || this.$i18n.t('global.validation.required.text')
          );
        }
      ];
    }
  },
  watch: {
    plateSelected(value, oldValue) {
      if (value.id === -1) {
        this.previousPlateSelected = oldValue;
        this.isShowingPlateCreateBottomSheet = true;
      } else {
        this.$emit('on-plate-selected', { plate: value });
      }
    },
    plates(value) {
      this.isShowingPlateCreateBottomSheet = false;
      if (value.length > 0 && this.internalPlates.length === 0) {
        this.internalPlates = _.cloneDeep(value);
        if (typeof this.plateCodeSelected !== 'undefined') {
          let tempPlateSelected = _.find(this.internalPlates, (it) => {
            return it.code === this.plateCodeSelected;
          });

          this.plateSelected = tempPlateSelected;
        } else {
          this.plateSelected = this.internalPlates[0];
        }
      }
      if (value.length > 0) {
        this.internalPlates.push({
          alias: '',
          code: this.$i18n.t('plates.createPlate.title'),
          id: -1
        });
      }
    }
  },
  destroyed() {},
  methods: {
    async updatePlates() {
      this.$emit('on-plate-added');
      this.isShowingPlateCreateBottomSheet = false;
    },
    closePlateCreateBottomSheet() {
      this.isShowingPlateCreateBottomSheet = false;
      if (this.previousPlateSelected) {
        this.plateSelected = this.previousPlateSelected;
        this.previousPlateSelected = null;
      }
    }
  }
};
</script>
